import { createFileRoute, useLocation } from '@tanstack/react-router';

import { LogbookGrid } from '@/features/logbook';

/**
 * The entry grid, opened on whichever entry the URL's hash names.
 *
 * Every link into the logbook from elsewhere in the app — a flight's "Review
 * entry" button, the flight list, an aircraft's flights — carries the entry's
 * id as the hash, because a link that only says "the logbook" leaves the
 * reader hunting. The hash is the row's `id` attribute too, so the browser
 * scrolls to it on its own; this hands it to the grid so the row is also
 * selected once it's there.
 *
 * Keyed on the hash: the grid seeds that selection at mount, so a second link
 * arriving while the logbook is already open has to be a fresh mount for it
 * to take. Everything the grid holds is either in Dexie or a per-visit
 * convenience, so there is nothing a remount loses that the navigation
 * wasn't already ending.
 */
function LogbookEntriesPage() {
  // Without the `#`, per TanStack Router's parsed location.
  const hash = useLocation({ select: (location) => location.hash });
  return <LogbookGrid key={hash} focusEntryId={hash} />;
}

export const Route = createFileRoute('/logbook/')({
  component: LogbookEntriesPage,
});
